export const borders = {
  default: { value: '1px solid ' },
  none: { value: 'none' },
};
